/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { GoodsInReceiptDto } from '../models/goods-in-receipt-dto';
import { OrderDirection } from '../models/order-direction';
import { PartFileDto } from '../models/part-file-dto';
import { PartFileDtoBaseResponse } from '../models/part-file-dto-base-response';
import { PartFileDtoListBaseResponse } from '../models/part-file-dto-list-base-response';
import { PartLocationDto } from '../models/part-location-dto';
import { PartLocationDtoDlmBaseResponse } from '../models/part-location-dto-dlm-base-response';
import { PartLocationDtoListDlmBaseResponse } from '../models/part-location-dto-list-dlm-base-response';
import { PartLocationDtoPagedResponseDlmBaseResponse } from '../models/part-location-dto-paged-response-dlm-base-response';
import { PartLocationStatsDlmBaseResponse } from '../models/part-location-stats-dlm-base-response';
import { PartLocationTreeNodeDtoListDlmBaseResponse } from '../models/part-location-tree-node-dto-list-dlm-base-response';
import { PartOptionListDlmBaseResponse } from '../models/part-option-list-dlm-base-response';
import { PartResponse } from '../models/part-response';
import { PartResponseDlmBaseResponse } from '../models/part-response-dlm-base-response';
import { PartResponseListDlmBaseResponse } from '../models/part-response-list-dlm-base-response';
import { PartResponseWithSubstitutes } from '../models/part-response-with-substitutes';
import { PartResponseWithSubstitutesDlmBaseResponse } from '../models/part-response-with-substitutes-dlm-base-response';
import { PartResponseWithSubstitutesListDlmBaseResponse } from '../models/part-response-with-substitutes-list-dlm-base-response';
import { PropertyFilter } from '../models/property-filter';
import { StockAdjustmentDto } from '../models/stock-adjustment-dto';

@Injectable({
  providedIn: 'root',
})
export class PartService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPartPartsGet
   */
  static readonly ApiPartPartsGetPath = '/api/Part/parts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
    includeSubstitutes?: boolean;
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
      rb.query('includeSubstitutes', params.includeSubstitutes, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
    includeSubstitutes?: boolean;
  }): Observable<PartResponseWithSubstitutesListDlmBaseResponse> {

    return this.apiPartPartsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>) => r.body as PartResponseWithSubstitutesListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
    includeSubstitutes?: boolean;
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
      rb.query('includeSubstitutes', params.includeSubstitutes, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
    includeSubstitutes?: boolean;
  }): Observable<PartResponseWithSubstitutesListDlmBaseResponse> {

    return this.apiPartPartsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesListDlmBaseResponse>) => r.body as PartResponseWithSubstitutesListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartReorderSuggestionsGet
   */
  static readonly ApiPartPartReorderSuggestionsGetPath = '/api/Part/part-reorder-suggestions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartReorderSuggestionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartReorderSuggestionsGet$Plain$Response(params?: {
    searchTerm?: string;
  }): Observable<StrictHttpResponse<PartResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartReorderSuggestionsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartReorderSuggestionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartReorderSuggestionsGet$Plain(params?: {
    searchTerm?: string;
  }): Observable<PartResponseListDlmBaseResponse> {

    return this.apiPartPartReorderSuggestionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseListDlmBaseResponse>) => r.body as PartResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartReorderSuggestionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartReorderSuggestionsGet$Json$Response(params?: {
    searchTerm?: string;
  }): Observable<StrictHttpResponse<PartResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartReorderSuggestionsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartReorderSuggestionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartReorderSuggestionsGet$Json(params?: {
    searchTerm?: string;
  }): Observable<PartResponseListDlmBaseResponse> {

    return this.apiPartPartReorderSuggestionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseListDlmBaseResponse>) => r.body as PartResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartFilteredPartsGet
   */
  static readonly ApiPartFilteredPartsGetPath = '/api/Part/filtered-parts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartFilteredPartsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartFilteredPartsGet$Plain$Response(params?: {
    filterText?: string;
    searchByDescription?: boolean;
  }): Observable<StrictHttpResponse<PartOptionListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartFilteredPartsGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
      rb.query('searchByDescription', params.searchByDescription, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartOptionListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartFilteredPartsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartFilteredPartsGet$Plain(params?: {
    filterText?: string;
    searchByDescription?: boolean;
  }): Observable<PartOptionListDlmBaseResponse> {

    return this.apiPartFilteredPartsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartOptionListDlmBaseResponse>) => r.body as PartOptionListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartFilteredPartsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartFilteredPartsGet$Json$Response(params?: {
    filterText?: string;
    searchByDescription?: boolean;
  }): Observable<StrictHttpResponse<PartOptionListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartFilteredPartsGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
      rb.query('searchByDescription', params.searchByDescription, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartOptionListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartFilteredPartsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartFilteredPartsGet$Json(params?: {
    filterText?: string;
    searchByDescription?: boolean;
  }): Observable<PartOptionListDlmBaseResponse> {

    return this.apiPartFilteredPartsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartOptionListDlmBaseResponse>) => r.body as PartOptionListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartGet
   */
  static readonly ApiPartPartGetPath = '/api/Part/part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartGet$Plain$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartGet$Plain(params?: {
    partId?: number;
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartGet$Json$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPartGet$Json(params?: {
    partId?: number;
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartPut
   */
  static readonly ApiPartPartPutPath = '/api/Part/part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPut$Plain$Response(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPut$Plain(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPut$Json$Response(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPut$Json(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartPost
   */
  static readonly ApiPartPartPostPath = '/api/Part/part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPost$Plain$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<PartResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPost$Plain(params?: {
    body?: PartResponse
  }): Observable<PartResponseDlmBaseResponse> {

    return this.apiPartPartPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseDlmBaseResponse>) => r.body as PartResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPost$Json$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<PartResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartPost$Json(params?: {
    body?: PartResponse
  }): Observable<PartResponseDlmBaseResponse> {

    return this.apiPartPartPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseDlmBaseResponse>) => r.body as PartResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartVersionPost
   */
  static readonly ApiPartPartVersionPostPath = '/api/Part/part-version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartVersionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartVersionPost$Plain$Response(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartVersionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartVersionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartVersionPost$Plain(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartVersionPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartVersionPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartVersionPost$Json$Response(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartVersionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartVersionPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartVersionPost$Json(params?: {
    body?: PartResponseWithSubstitutes
  }): Observable<PartResponseWithSubstitutesDlmBaseResponse> {

    return this.apiPartPartVersionPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseWithSubstitutesDlmBaseResponse>) => r.body as PartResponseWithSubstitutesDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartVerifyPartPut
   */
  static readonly ApiPartVerifyPartPutPath = '/api/Part/verify-part';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartVerifyPartPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartVerifyPartPut$Plain$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartVerifyPartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartVerifyPartPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartVerifyPartPut$Plain(params?: {
    body?: PartResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartVerifyPartPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartVerifyPartPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartVerifyPartPut$Json$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartVerifyPartPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartVerifyPartPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartVerifyPartPut$Json(params?: {
    body?: PartResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartVerifyPartPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPartInlinePut
   */
  static readonly ApiPartPartInlinePutPath = '/api/Part/part-inline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartInlinePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartInlinePut$Plain$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<PartResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartInlinePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartInlinePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartInlinePut$Plain(params?: {
    body?: PartResponse
  }): Observable<PartResponseDlmBaseResponse> {

    return this.apiPartPartInlinePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseDlmBaseResponse>) => r.body as PartResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPartInlinePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartInlinePut$Json$Response(params?: {
    body?: PartResponse
  }): Observable<StrictHttpResponse<PartResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPartInlinePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPartInlinePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartPartInlinePut$Json(params?: {
    body?: PartResponse
  }): Observable<PartResponseDlmBaseResponse> {

    return this.apiPartPartInlinePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartResponseDlmBaseResponse>) => r.body as PartResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartArchivePost
   */
  static readonly ApiPartArchivePostPath = '/api/Part/archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartArchivePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchivePost$Plain$Response(params?: {
    partId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartArchivePostPath, 'post');
    if (params) {
      rb.query('partId', params.partId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartArchivePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchivePost$Plain(params?: {
    partId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartArchivePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartArchivePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchivePost$Json$Response(params?: {
    partId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartArchivePostPath, 'post');
    if (params) {
      rb.query('partId', params.partId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartArchivePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchivePost$Json(params?: {
    partId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartArchivePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartUpdateStockAndLocationsFromGoodsInPut
   */
  static readonly ApiPartUpdateStockAndLocationsFromGoodsInPutPath = '/api/Part/update-stock-and-locations-from-goods-in';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateStockAndLocationsFromGoodsInPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockAndLocationsFromGoodsInPut$Plain$Response(params?: {
    updateLastReceivedDate?: boolean;
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateStockAndLocationsFromGoodsInPutPath, 'put');
    if (params) {
      rb.query('updateLastReceivedDate', params.updateLastReceivedDate, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateStockAndLocationsFromGoodsInPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockAndLocationsFromGoodsInPut$Plain(params?: {
    updateLastReceivedDate?: boolean;
    body?: GoodsInReceiptDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartUpdateStockAndLocationsFromGoodsInPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateStockAndLocationsFromGoodsInPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockAndLocationsFromGoodsInPut$Json$Response(params?: {
    updateLastReceivedDate?: boolean;
    body?: GoodsInReceiptDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateStockAndLocationsFromGoodsInPutPath, 'put');
    if (params) {
      rb.query('updateLastReceivedDate', params.updateLastReceivedDate, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateStockAndLocationsFromGoodsInPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockAndLocationsFromGoodsInPut$Json(params?: {
    updateLastReceivedDate?: boolean;
    body?: GoodsInReceiptDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartUpdateStockAndLocationsFromGoodsInPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartUpdateStockFromStockAdjustmentPut
   */
  static readonly ApiPartUpdateStockFromStockAdjustmentPutPath = '/api/Part/update-stock-from-stock-adjustment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateStockFromStockAdjustmentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockFromStockAdjustmentPut$Plain$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateStockFromStockAdjustmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateStockFromStockAdjustmentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockFromStockAdjustmentPut$Plain(params?: {
    body?: StockAdjustmentDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartUpdateStockFromStockAdjustmentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateStockFromStockAdjustmentPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockFromStockAdjustmentPut$Json$Response(params?: {
    body?: StockAdjustmentDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateStockFromStockAdjustmentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateStockFromStockAdjustmentPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateStockFromStockAdjustmentPut$Json(params?: {
    body?: StockAdjustmentDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartUpdateStockFromStockAdjustmentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartLocationsGet
   */
  static readonly ApiPartLocationsGetPath = '/api/Part/locations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<PartLocationDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<PartLocationDtoListDlmBaseResponse> {

    return this.apiPartLocationsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoListDlmBaseResponse>) => r.body as PartLocationDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<PartLocationDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<PartLocationDtoListDlmBaseResponse> {

    return this.apiPartLocationsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoListDlmBaseResponse>) => r.body as PartLocationDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartPaginatedLocationsGet
   */
  static readonly ApiPartPaginatedLocationsGetPath = '/api/Part/paginated-locations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPaginatedLocationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPaginatedLocationsGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPaginatedLocationsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPaginatedLocationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPaginatedLocationsGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<PartLocationDtoPagedResponseDlmBaseResponse> {

    return this.apiPartPaginatedLocationsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>) => r.body as PartLocationDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartPaginatedLocationsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPaginatedLocationsGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartPaginatedLocationsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartPaginatedLocationsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartPaginatedLocationsGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<PartLocationDtoPagedResponseDlmBaseResponse> {

    return this.apiPartPaginatedLocationsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoPagedResponseDlmBaseResponse>) => r.body as PartLocationDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartLocationStatsGet
   */
  static readonly ApiPartLocationStatsGetPath = '/api/Part/location-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationStatsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<PartLocationStatsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationStatsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationStatsGet$Plain(params?: {
  }): Observable<PartLocationStatsDlmBaseResponse> {

    return this.apiPartLocationStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationStatsDlmBaseResponse>) => r.body as PartLocationStatsDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationStatsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<PartLocationStatsDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationStatsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationStatsDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationStatsGet$Json(params?: {
  }): Observable<PartLocationStatsDlmBaseResponse> {

    return this.apiPartLocationStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationStatsDlmBaseResponse>) => r.body as PartLocationStatsDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartLocationTreeGet
   */
  static readonly ApiPartLocationTreeGetPath = '/api/Part/location-tree';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationTreeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationTreeGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationTreeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationTreeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationTreeGet$Plain(params?: {
  }): Observable<PartLocationTreeNodeDtoListDlmBaseResponse> {

    return this.apiPartLocationTreeGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>) => r.body as PartLocationTreeNodeDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartLocationTreeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationTreeGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartLocationTreeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartLocationTreeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartLocationTreeGet$Json(params?: {
  }): Observable<PartLocationTreeNodeDtoListDlmBaseResponse> {

    return this.apiPartLocationTreeGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationTreeNodeDtoListDlmBaseResponse>) => r.body as PartLocationTreeNodeDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartCreateLocationPost
   */
  static readonly ApiPartCreateLocationPostPath = '/api/Part/create-location';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartCreateLocationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartCreateLocationPost$Plain$Response(params?: {
    body?: PartLocationDto
  }): Observable<StrictHttpResponse<PartLocationDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartCreateLocationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartCreateLocationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartCreateLocationPost$Plain(params?: {
    body?: PartLocationDto
  }): Observable<PartLocationDtoDlmBaseResponse> {

    return this.apiPartCreateLocationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoDlmBaseResponse>) => r.body as PartLocationDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartCreateLocationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartCreateLocationPost$Json$Response(params?: {
    body?: PartLocationDto
  }): Observable<StrictHttpResponse<PartLocationDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartCreateLocationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartCreateLocationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartCreateLocationPost$Json(params?: {
    body?: PartLocationDto
  }): Observable<PartLocationDtoDlmBaseResponse> {

    return this.apiPartCreateLocationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoDlmBaseResponse>) => r.body as PartLocationDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartEditLocationPut
   */
  static readonly ApiPartEditLocationPutPath = '/api/Part/edit-location';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartEditLocationPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartEditLocationPut$Plain$Response(params?: {
    body?: PartLocationDto
  }): Observable<StrictHttpResponse<PartLocationDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartEditLocationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartEditLocationPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartEditLocationPut$Plain(params?: {
    body?: PartLocationDto
  }): Observable<PartLocationDtoDlmBaseResponse> {

    return this.apiPartEditLocationPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoDlmBaseResponse>) => r.body as PartLocationDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartEditLocationPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartEditLocationPut$Json$Response(params?: {
    body?: PartLocationDto
  }): Observable<StrictHttpResponse<PartLocationDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartEditLocationPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartLocationDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartEditLocationPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartEditLocationPut$Json(params?: {
    body?: PartLocationDto
  }): Observable<PartLocationDtoDlmBaseResponse> {

    return this.apiPartEditLocationPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartLocationDtoDlmBaseResponse>) => r.body as PartLocationDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartArchiveLocationPost
   */
  static readonly ApiPartArchiveLocationPostPath = '/api/Part/archive-location';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartArchiveLocationPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchiveLocationPost$Plain$Response(params?: {
    locationId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartArchiveLocationPostPath, 'post');
    if (params) {
      rb.query('locationId', params.locationId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartArchiveLocationPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchiveLocationPost$Plain(params?: {
    locationId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartArchiveLocationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartArchiveLocationPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchiveLocationPost$Json$Response(params?: {
    locationId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartArchiveLocationPostPath, 'post');
    if (params) {
      rb.query('locationId', params.locationId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartArchiveLocationPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartArchiveLocationPost$Json(params?: {
    locationId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPartArchiveLocationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartImportPartSuppliersPost
   */
  static readonly ApiPartImportPartSuppliersPostPath = '/api/Part/import-part-suppliers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartImportPartSuppliersPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartImportPartSuppliersPost$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartImportPartSuppliersPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartImportPartSuppliersPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartImportPartSuppliersPost$Plain(params?: {
  }): Observable<boolean> {

    return this.apiPartImportPartSuppliersPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartImportPartSuppliersPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartImportPartSuppliersPost$Json$Response(params?: {
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartImportPartSuppliersPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartImportPartSuppliersPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartImportPartSuppliersPost$Json(params?: {
  }): Observable<boolean> {

    return this.apiPartImportPartSuppliersPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiPartImportPartCostsPost
   */
  static readonly ApiPartImportPartCostsPostPath = '/api/Part/import-part-costs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartImportPartCostsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartImportPartCostsPost$Plain$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartImportPartCostsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartImportPartCostsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartImportPartCostsPost$Plain(params?: {
    body?: string
  }): Observable<boolean> {

    return this.apiPartImportPartCostsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartImportPartCostsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartImportPartCostsPost$Json$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartImportPartCostsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartImportPartCostsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartImportPartCostsPost$Json(params?: {
    body?: string
  }): Observable<boolean> {

    return this.apiPartImportPartCostsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiPartGetFilesGet
   */
  static readonly ApiPartGetFilesGetPath = '/api/Part/get-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartGetFilesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartGetFilesGet$Plain$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<PartFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartGetFilesGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartGetFilesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartGetFilesGet$Plain(params?: {
    partId?: number;
  }): Observable<PartFileDtoListBaseResponse> {

    return this.apiPartGetFilesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoListBaseResponse>) => r.body as PartFileDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartGetFilesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartGetFilesGet$Json$Response(params?: {
    partId?: number;
  }): Observable<StrictHttpResponse<PartFileDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartGetFilesGetPath, 'get');
    if (params) {
      rb.query('partId', params.partId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartGetFilesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartGetFilesGet$Json(params?: {
    partId?: number;
  }): Observable<PartFileDtoListBaseResponse> {

    return this.apiPartGetFilesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoListBaseResponse>) => r.body as PartFileDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartUploadFilePartIdPost
   */
  static readonly ApiPartUploadFilePartIdPostPath = '/api/Part/upload-file/{partId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUploadFilePartIdPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPartUploadFilePartIdPost$Plain$Response(params: {
    partId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUploadFilePartIdPostPath, 'post');
    if (params) {
      rb.path('partId', params.partId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUploadFilePartIdPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPartUploadFilePartIdPost$Plain(params: {
    partId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartUploadFilePartIdPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUploadFilePartIdPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPartUploadFilePartIdPost$Json$Response(params: {
    partId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUploadFilePartIdPostPath, 'post');
    if (params) {
      rb.path('partId', params.partId, {});
      rb.query('filename', params.filename, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUploadFilePartIdPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPartUploadFilePartIdPost$Json(params: {
    partId: number;
    filename?: string;
    body?: { 'formFile'?: Blob }
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartUploadFilePartIdPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartUpdateFilePost
   */
  static readonly ApiPartUpdateFilePostPath = '/api/Part/update-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateFilePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateFilePost$Plain$Response(params?: {
    body?: PartFileDto
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateFilePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateFilePost$Plain(params?: {
    body?: PartFileDto
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartUpdateFilePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartUpdateFilePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateFilePost$Json$Response(params?: {
    body?: PartFileDto
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartUpdateFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartUpdateFilePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPartUpdateFilePost$Json(params?: {
    body?: PartFileDto
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartUpdateFilePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiPartDownloadFileFileIdGet
   */
  static readonly ApiPartDownloadFileFileIdGetPath = '/api/Part/download-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartDownloadFileFileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDownloadFileFileIdGet$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartDownloadFileFileIdGetPath, 'get');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartDownloadFileFileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDownloadFileFileIdGet(params: {
    fileId: number;
  }): Observable<string> {

    return this.apiPartDownloadFileFileIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiPartDeleteFileFileIdDelete
   */
  static readonly ApiPartDeleteFileFileIdDeletePath = '/api/Part/delete-file/{fileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartDeleteFileFileIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDeleteFileFileIdDelete$Plain$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartDeleteFileFileIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDeleteFileFileIdDelete$Plain(params: {
    fileId: number;
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartDeleteFileFileIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPartDeleteFileFileIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDeleteFileFileIdDelete$Json$Response(params: {
    fileId: number;
  }): Observable<StrictHttpResponse<PartFileDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartService.ApiPartDeleteFileFileIdDeletePath, 'delete');
    if (params) {
      rb.path('fileId', params.fileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PartFileDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPartDeleteFileFileIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPartDeleteFileFileIdDelete$Json(params: {
    fileId: number;
  }): Observable<PartFileDtoBaseResponse> {

    return this.apiPartDeleteFileFileIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PartFileDtoBaseResponse>) => r.body as PartFileDtoBaseResponse)
    );
  }

}
